<template>
  <v-footer  width="100%" tile=""
    dark class="primary"
    padless>
    <v-layout column="">
      <v-container grid-list-xs>
        <v-layout class="py-3">
          <v-img  
            class="" 
            height="60"  
            max-width="60"
            :src="require(`@/assets/teresiansisters/logo.png`)"
          /> 
          <v-spacer></v-spacer>
          <div class=" ">
            <h4 class="pl-2 pb-2 white--text">CONNECT WITH US</h4>
            <v-layout row wrap class="ml-2"> 
              <div v-for="(icon, index) in icons"
                :key="index">
                <a :href="icon.link " target="_blank" rel="noopener noreferrer" class="not-line0">
                  <v-btn  class="mx-2 white" color="" icon>
                    <v-icon color="primary" size="24px">{{ icon.src }}</v-icon>
                  </v-btn>
                
                </a>
              </div> 
            </v-layout> 
          </div>
        </v-layout>
        
        
      </v-container>
      <v-divider></v-divider>
      <v-container  class="mb-0 py-0"> 
        <v-row class="mb-0 pb-0">
          <v-col sm="2"  class="pa-0">
            <v-layout fill-height="">
              <div class="pa-3">
                <h4 class="white--text">TERESIAN SISTER</h4>
                <br>
                <P>P.O. Box 477<br>
                Area <br>
                Lilongwe <br>
                Malawi</P> 
              </div>
              <v-spacer></v-spacer>
              <v-divider vertical=""></v-divider> 
            </v-layout>
          </v-col>
          <v-col sm="3"  cols="12" class="pa-0">
            <v-layout >
              <div  class="pa-3">
                <h4 class="white--text">IMPORTANT TIME</h4>
                <br>
                <P>Sunday morning service <br> @ 09h00 To 12h00</P>
                <!-- <P>Sunday morning service <br> @ 19h00</P> -->
              </div>
              <v-spacer></v-spacer>
              <v-divider vertical=""></v-divider> 
            </v-layout>
          </v-col>
          <v-col  >
            <v-layout fill-height="" align-center="" justify-center="">
             <div class="not-f6 text-center">
                  An association of committed, united and sustainable consecrated women, holistically formed and witnessing the Gospel values.
              </div>   
            </v-layout>
          </v-col>
        </v-row> 
      </v-container> 
      <v-divider></v-divider> 
      <v-container class=" ">
        <a href="https://mberasolutions.com/" target="_blank" rel="noopener noreferrer" class="white--text  not-line0">
          <v-layout justify-center="" align-center="">
            <strong class="not-f7 pr-1">&copy;</strong> 
            {{ new Date().getFullYear()}} -
            <v-img class="mt-1 me-1 ml-1" 
                :src="require(`@/assets/mbe/logo-w.png`)" 
                height="25"
                max-width="25" /> 
            <strong >Mbera Solutions</strong>
          </v-layout>  
        </a>
      </v-container>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  props:["not"],
  data: () => ({ 
    icons: [
      {name:"facebook",src:"fab fa-facebook",link:"https://web.facebook.com/search/top/?q=pentecost%20philadelphia%20evangelical%20church&ref=eyJzaWQiOiIwLjE5NzYwNDI3MzE5OTMzMDYiLCJxcyI6IkpUVkNKVEl5Y0dWdWRHVmpiM04wSlRJd2NHaHBiR0ZrWld4d2FHbGhKVEl3WlhaaGJtZGxiR2xqWVd3bE1qQmphSFZ5WTJnbE1qSWxOVVEiLCJndiI6ImJlZTA5ZjkzZmE3MzJjZmE1OWExY2I2ZDlmNDUwZDM4OTI0MjRlNDkiLCJlbnRfaWRzIjpbXSwiYnNpZCI6ImM0NmVkNmUyMjU0OTAzMzMyZGMyYWVjZTJkNWFhMGYzIiwicHJlbG9hZGVkX2VudGl0eV9pZHMiOm51bGwsInByZWxvYWRlZF9lbnRpdHlfdHlwZSI6bnVsbCwicmVmIjoiYnJfdGYiLCJjc2lkIjpudWxsLCJoaWdoX2NvbmZpZGVuY2VfYXJndW1lbnQiOm51bGwsImNsaWVudF90aW1lX21zIjoxNTcyODM5MTEzNTkxfQ&epa=SEARCH_BOX"},
      {name:"youtube",src:"fab fa-youtube",link:"https://www.youtube.com/channel/UCW8snUavgdQ6DOoG9ITFMHA?view_as=subscriber"},
      {name:"googleplus",src:"fab fa-google-plus",link:""},  
        // 'fab fa-linkedin',
        // 'fab fa-instagram',
      ],
  }),
};
</script>
